import { useMemo } from 'react';
import { storageService } from 'js/services/storage.service';

export const useCategoriesVariables = () => {
    const catName = storageService.local.getItem('catName');

    const categoryName = useMemo(() => {
        return catName ? JSON.parse(catName)?.displayCategoryName : null;
    }, [catName]);

    const mostPlayedGame = useMemo(() => {
        return catName ? JSON.parse(catName)?.mostPlayedGame : null;
    }, [catName]);

    const isCategoryName = categoryName && categoryName !== 'undefined' && categoryName !== '';

    const isRecommended = useMemo(() => {
        return categoryName && (categoryName.indexOf('Recommended All') !== -1 || categoryName.indexOf('Recommended Live') !== -1);
    }, [categoryName]);

    const isBecauseYouPlayed = useMemo(() => {
        return categoryName && categoryName.indexOf('Because you played') !== -1;
    }, [categoryName]);

    return {
        isBecauseYouPlayed,
        categoryName,
        isRecommended,
        isCategoryName,
        mostPlayedGame
    };
};
